import * as React from 'react';
import PropTypes from 'prop-types';
import _ from 'helpers/no_conflict_lodash';

import { MenuItem } from 'react-bootstrap';

import './tags_card.scss';

export default class TagsDropdown extends React.Component {
  static propTypes = {
    currentValue: PropTypes.string.isRequired,
    filter: PropTypes.bool,
    firstLoad: PropTypes.bool,
    tags: PropTypes.arrayOf(PropTypes.string).isRequired,
    onAdd: PropTypes.func.isRequired
  };

  newTag = () => {
    const { currentValue } = this.props;

    if (currentValue.length < 3) return null;

    return (
      <MenuItem
        key="newTag"
        onClick={() => this.props.onAdd(currentValue)}
      >
        {`${currentValue} (Create New Tag)`}
      </MenuItem>
    );
  };

  emptyFilterTag = () => {
    return (
      <MenuItem
        disabled={true}
        key="emptyFilterTag"
      >
        No Matching Tags
      </MenuItem>
    );
  }

  suggestions() {
    const { filter, firstLoad, tags } = this.props;

    const tagItems = _.map(tags, (tag, index) => (
      <MenuItem
        key={index}
        onClick={() => this.props.onAdd(tag)}
      >
        {tag}
      </MenuItem>
    ));

    if (!filter) tagItems.push(this.newTag());
    if (filter && tags.length < 1 && firstLoad) tagItems.push(this.emptyFilterTag());

    return (
      <React.Fragment>
        {tagItems}
      </React.Fragment>
    );
  }

  render() {
    return (
      <ul className="tags-dropdown dropdown-menu open">
        {this.suggestions()}
      </ul>
    );
  }
}
